import {AfterViewInit, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {HttpClient} from '@angular/common/http';

import '../../node_modules/bootstrap/dist/css/bootstrap.css';
import '../../node_modules/primeng/resources/primeng.min.css';
import '../../node_modules/font-awesome/css/font-awesome.min.css';

import 'cropperjs/dist/cropper.css';
import 'jodit/build/jodit.min.css';
import 'codemirror/lib/codemirror.css';
import 'codemirror/theme/cobalt.css';

import '../assets/css/styles.css';

import {SelectItem} from 'primeng/primeng';
import {Message} from "primeng/components/common/api";

import * as $ from 'jquery';
import * as _ from 'lodash';

import {Site} from "../api/model/site";
import {AwsService} from "./aws.service";
import {Router} from "@angular/router";
import {User} from "../api/model/user";
import {config} from "./config";

@Component({
    selector: 'my-app',
    template: require('./app.component.pug'),
    styles: [require('./app.component.css')]
})
export class AppComponent implements OnInit, AfterViewInit {
    @ViewChild('shac') el: ElementRef;
    msgs: Message[] = [];

    sites: SelectItem[] = [];
    selectedSite: Site;

    uploadConf: boolean = false;

    identityId: string;
    user: User = {};

    config = config;

    constructor(private window: Window, private _router: Router, private _awsService: AwsService, private _httpClient: HttpClient) {
        console.log('[AppComponent][constructor]',);
        this.identityId = this._awsService.identityId;
        this.sites.push({label: 'Selecciona un site', value: null});

        this._awsService.sites$.subscribe((sites: Site[]) => {
            this.sites = [];
            this.sites.push({label: 'Selecciona un site', value: null});
            sites.forEach((site) => this.sites.push({label: site.id, value: site}));
            if (!sites.length) return;
            const currentSite = localStorage.getItem('currentSite');
            if (currentSite) {
                const site = _.find(sites, {id: currentSite});
                if (site) {
                    this.selectedSite = site;
                } else {
                    this.selectedSite = sites[0];
                    localStorage.setItem('currentSite', sites[0].id);
                }
            } else {
                this.selectedSite = sites[0];
                localStorage.setItem('currentSite', sites[0].id);
            }

            this.config.sites = sites;
            this.config.site = this.selectedSite;

            this.loadSite(this.selectedSite.id).then();
        });
        this._awsService.user$.subscribe((data: any) => this.user = data);
    }

    ngOnInit(): void {
        console.log('[AppComponent][ngOnInit]');
        let data = localStorage.getItem('userSites');
        if (data) {
            let sites: Site[] = JSON.parse(data);
            this.sites = [];
            this.sites.push({label: 'Selecciona un site', value: null});
            for (let site of sites) {
                this.sites.push({label: site.id, value: site.id});
            }
        }
    }

    ngAfterViewInit(): void {
        let shac = $(this.el.nativeElement);
        let sidebar = shac.find('#sidebar');
        let navIcon = shac.find('#fa');
        let navIconm = shac.find('#fam');
        let menu2 = shac.find('#menu2');
        let ventAyuda = shac.find('.sha-ayuda');
        let cSupport = shac.find('#cSupport');
        let icAyuda = shac.find('.sha-int-not');
        let contsearch = shac.find('#modal');
        let shaSelectweb = shac.find('.sha-selectweb');
        let shaenlsupport = shac.find('#sha-enl-support');
        let lisearch = shac.find('#li-search');

        shac.find('#hamburger').click(function () {
            if (navIcon.hasClass('sha-sidebar-open')) {
                sidebar.animate({left: '-210px'}, 10);
                navIcon.removeClass('sha-sidebar-open fa-times');
                navIcon.addClass('fa-navicon');

            } else {
                sidebar.animate({left: 0}, 10);
                navIcon.addClass('sha-sidebar-open fa-times');
                navIcon.removeClass('fa-navicon');
            }
        });

        shac.find('.sha-pantalla, #mt, .sha-headm, .sha-ms a').click(function () {
            if (navIcon.hasClass('sha-sidebar-open')) {
                sidebar.animate({left: '-210px'}, 10);
                navIcon.removeClass('sha-sidebar-open fa-times');
                navIcon.addClass('fa-navicon');

            } else {

            }
        });

        shac.find('#hamburgerm').click(function () {
            if (navIconm.hasClass('sha-sidebar-open')) {
                sidebar.animate({left: '-280px'}, 10);
                navIconm.removeClass('sha-sidebar-open fa-times');
                navIconm.addClass('fa-navicon');

            } else {
                sidebar.animate({left: 0}, 10);
                navIconm.addClass('sha-sidebar-open fa-times');
                navIconm.removeClass('fa-navicon');
            }
        });

        shac.find('#li-search, li.sha-searchm').click(function () {
            if (contsearch.hasClass('sha-sidebar-open')) {
                contsearch.hide();
                sidebar.css('display', 'block');
                menu2.show();
                shaSelectweb.show();
                shaenlsupport.show();
                lisearch.show();
                shaenlsupport.show();
                contsearch.removeClass('sha-sidebar-open');
            } else {
                contsearch.slideDown();
                sidebar.css('display', 'none');
                menu2.hide();
                shaSelectweb.hide();
                shaenlsupport.hide();
                lisearch.hide();
                shaenlsupport.hide();
                cSupport.css('right', '-350px');
                cSupport.removeClass('cSupport-open');
                contsearch.addClass('sha-sidebar-open');
            }
        });

        shac.find('.sha-exit-search .i.fa.fa-times').click(function () {
            contsearch.slideUp();
            sidebar.css('display', 'block');
            menu2.show();
            shaSelectweb.show();
            shaenlsupport.show();
            lisearch.show();
            shaenlsupport.show();
            contsearch.removeClass('sha-sidebar-open');
        });


        shac.find('#sha-enl-support').click(function () {
            if (cSupport.hasClass('cSupport-open')) {
                cSupport.animate({'right': '-350px'}, 300);
                cSupport.removeClass('cSupport-open');


            } else {
                cSupport.animate({'right': '0px'}, 300);
                cSupport.addClass('cSupport-open');

            }
        });

        shac.find('#exsupport').click(function () {
            cSupport.animate({'right': '-350px'}, 300);
            cSupport.removeClass('cSupport-open');
        });
    }

    async onChangeSite() {
        if (this.selectedSite && this.selectedSite.id !== localStorage.getItem('currentSite')) {
            localStorage.setItem('currentSite', this.selectedSite.id);
            await this.loadSite(this.selectedSite.id);
            this._router.navigate(['/']);
        }
    }

    async loadSite(id: string) {
        console.log('loadSite: ', id);
        this.config.roles = (await this._awsService.api.sitesSiteRolesGet({site: id})).data.items;
        this.config.themes = (await this._awsService.api.sitesSiteThemesGet({site: id})).data.items;
        this.config.schemas = (await this._awsService.api.sitesSiteSchemasGet({site: id})).data.items;
    }

    async preview() {
        this.msgs = [];
        const currentSite = localStorage.getItem('currentSite');
        this.msgs.push({severity: 'success', summary: 'En unos instantes se abrirá el navegador con la previsualización.'});
        try {
            const url = 'https://sites.sintesis.io/deploy/' + config.STAGE + '/site/' + currentSite + '/preview';
            let res = await this._httpClient.get(url).toPromise();
            console.log(res);
            let siteUrl = 'https://' +currentSite;
            if (config.STAGE !== 'prod') siteUrl += '-' + config.STAGE;
            siteUrl += '-prev.sintesis.io/';
            console.log(siteUrl);
            window.open(siteUrl);
        } catch (err) {
            this.msgs.push({severity: 'error', summary: 'Error en la previsualización'});
        }
    }

    async publish() {
        this.msgs = [];
        const currentSite = localStorage.getItem('currentSite');
        if (!currentSite) return;
        try {
            const url = 'https://sites.sintesis.io/deploy/' + config.STAGE + '/site/' + currentSite + '/publish';
            const res = await this._httpClient.get(url).toPromise();
            console.log(res);
            let siteUrl = 'https://' +currentSite;
            if (config.STAGE !== 'prod') siteUrl += '-' + config.STAGE;
            siteUrl += '.sintesis.io/';
            console.log(siteUrl);
            this.uploadConf = false;
            window.open(siteUrl);
        } catch (err) {
            this.msgs.push({severity: 'error', summary: 'Error en la publicación'});
        }
    }

    async signOut() {
        await this._awsService.singOut();
        this._router.navigate(['/signin']);
    }
    async confUpload() {
        this.uploadConf = true;
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/app.component.ts